import { Component, OnInit } from "@angular/core";
import { LoginService } from "../service/login/login.service";
import { NzMessageService } from "ng-zorro-antd";
import { NzModalService } from "ng-zorro-antd";
import { DomSanitizer } from "@angular/platform-browser";

import * as $ from "jquery";

@Component({
  selector: "app-detail",
  templateUrl: "./detail.component.html",
  styleUrls: ["./detail.component.css"],
})
export class DetailComponent implements OnInit {
  title: any;
  time: any;
  content: any;
  img: any;
  id: any;
  imgList: any[];
  MethodService: any;
  render;
  downReport: boolean;
  constructor(
    private sanitizer: DomSanitizer,
    private service: LoginService,
    private message: NzMessageService,
    private modalService: NzModalService
  ) {}

  ngOnInit() {
    this.title = localStorage.getItem("detailtit");
    this.time = localStorage.getItem("detailtime");
    this.content = localStorage.getItem("detailcontent");
    this.content = this.sanitizer.bypassSecurityTrustHtml(this.content);
    this.img = localStorage.getItem("detailImg");
    this.id = localStorage.getItem("detailid");
    var lists = this.img.split(",");
    this.imgList = lists;
    console.log(this.img);
    console.log(this.title);
    console.log(this.time);
    console.log(this.content);
    console.log(this.id);
    console.log(lists);
    console.log(this.imgList);
  }

  // 字体大小
  plus() {
    console.log("点击变大");
    var para = document.getElementById("writing");

    var s = para.style.fontSize; //利用+将i和px连接起来
    console.log(s);

    // console.log(para);
    // var s = para.style.fontSize;
    if ((para.style.fontSize = "24px")) {
      this.modalService.warning({
        nzTitle: "已是最大字体！",
        nzContent: "字体大小不可再增大！",
      });
    } else {
      var size = parseInt(s) + 1;
      para.style.fontSize = size + "px";
    }
  }

  minus() {
    console.log("点击变小");
    var para2 = document.getElementById("writing");
    var s = para2.style.fontSize;
    if (parseInt(s) == 14) {
      this.modalService.warning({
        nzTitle: "已是最小字体！",
        nzContent: "字体大小不可再减小！",
      });
    } else {
      var size = parseInt(s) - 1;
      para2.style.fontSize = size + "px";
    }
  }

  // 段落缩进
  // submitText() {
  //   let arr = [];
  //   this.content.split('').forEach(item => arr.push(`<p>${item.trim()}</p>`));
  //   this.content = arr.join('<br>');
  //   console.log("生效否？");
  //   // $('p').css('text-indent', '20px');
  //   // $('p').css({ 'text-indent': '2em', 'margin': '0px' })

  // }

  // 下载为PDF
  // downloadPDF() {
  //   console.log("点击事件");
  //   window['jsPDF'] = jsPDF;
  //   let node = document.getElementById('content');
  //   domtoimage.toJpeg(node, {
  //     // quality: 1.0,
  //     bgcolor: '#fff',
  //     style: {
  //       'opacity': '1',
  //       'width': '1000px',
  //       'marginLeft': '0'
  //       // 'top': '0',
  //       // 'left': '0'
  //     }
  //   })
  //     .then((dataUrl) => {
  //       console.log(dataUrl)
  //       let img = new Image();
  //       img.src = dataUrl;
  //       console.log(img)
  //       img.onload = () => {
  //         let pdf = new jsPDF();
  //         pdf.addImage(dataUrl, 'JPEG', 50, 10, img.width / 12, img.height / 12);//300DPI 1mm=12px
  //         // pdf.addImage(dataUrl, 'JPEG', 14, 10, img.width / 12, img.height / 12);//300DPI 1mm=12px
  //         pdf.save(`${name}.pdf`);
  //       }
  //       console.log(img.width)
  //     })
  //     .then(() => {
  //       this.downReport = false;
  //     });
  // }
}
